import {connect} from '../../app/connect';
import NoPermissionsModal from './NoPermissionsModal';

import {getPermissionsHasGrowled, hasPermissionsViolation} from '../../app/selectors';

const mapStateToProps = state => ({
  hasViolation: hasPermissionsViolation(state),
  hasGrowled: getPermissionsHasGrowled(state)
});

export default connect(mapStateToProps)(NoPermissionsModal);
